"use client";

import { useCallback, useState } from "react";
import { DEFAULT_MODEL, isValidModelId, type ModelId } from "@/lib/model-id";

// Model IDs are dynamic — sourced from the global_models DB table.
// Defined in @/lib/model-id so server code can share them.
export { isValidModelId, type ModelId };

export type ModelDef = {
  id: ModelId;
  label: string;
  description: string;
};

// Static fallback definitions used when the DB model list hasn't loaded yet.
export const MODELS: ModelDef[] = [
  {
    id: "claude-sonnet-5-5",
    label: "Sonnet 5.5",
    description: "Balanced performance and speed",
  },
  {
    id: "claude-opus-5-5",
    label: "Opus 5.5",
    description: "Most capable, best for complex tasks",
  },
  {
    id: "claude-haiku-4-5",
    label: "Haiku 4.5",
    description: "Fastest, best for simple tasks",
  },
];

const STORAGE_KEY = "woods-ai:preferred-model";

export const useModel = () => {
  const [model, setModelState] = useState<ModelId>(() => {
    if (typeof window === "undefined") {
      return DEFAULT_MODEL;
    }

    const stored = localStorage.getItem(STORAGE_KEY);
    return isValidModelId(stored) ? stored : DEFAULT_MODEL;
  });

  const setModel = useCallback((newModel: ModelId) => {
    setModelState(newModel);
    localStorage.setItem(STORAGE_KEY, newModel);
  }, []);

  return { model, setModel, models: MODELS };
};
